import { useCallback } from "react";

export const useAutoFocusCallback = () => {
  return useCallback(element => {
    if (element) {
      setTimeout(() => element.focus());
    }
  }, []);
};